import type { Board } from "../board";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import type { Mob } from "../mob";
import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeThing, deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class RockMobCave extends DestroyableObstacle implements ProcessableThing {
	static key = "RockMobCave";
	private mobQueue: Mob[] = [];

	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.ROCK_DEBRIS;
	}

	addMob(mob: Mob): void {
		this.mobQueue.push(mob);
	}

	addMobs(mobs: Mob[]): void {
		this.mobQueue.push(...mobs);
	}

	processTurn(board: Board): void {
		if (this.mobQueue.length === 0) return;
		if (board.hasMob(this.xy)) return;

		const mob = this.mobQueue.shift()!;
		mob.xy = this.xy;
		board.addThing(mob);
		mob.gold = board.spendGoldBudget(mob.getBaseGoldValue());
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			mobQueue: this.mobQueue.map((m) => m.serialize()),
		};
	}

	static deserialize(data: any): RockMobCave {
		const c = new RockMobCave(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		if (data.mobQueue) {
			c.mobQueue = data.mobQueue.map((m: any) => deserializeThing(m) as Mob);
		}
		return c;
	}
}
